import { appSelectors } from '@appStore/reducers/app'
import HintTooltip from 'components/atoms/HintTooltip'
import { CONSTS } from 'config/objectConst'
import { campaignsSelectors } from 'features/campaigns/slice'
import { memo, useState } from 'react'
import { useAppSelector } from 'shared/hooks'
import { isValidOnBoardingConditions } from 'tools/function.types'

const getInitValue = () => Boolean(localStorage.getItem('2.6'))

function TableHint_({ forceHide }: { forceHide?: boolean }) {
	const [isLocalHide, setIsLocalHide] = useState(getInitValue)

	const appProfile = useAppSelector(appSelectors.appProfile),
		isUpdatingTable = useAppSelector(campaignsSelectors.isUpdatingTable)

	const shouldHide = forceHide || isUpdatingTable || isLocalHide

	return (
		<HintTooltip
			classes='add-contacts-tooltip'
			enabled={isValidOnBoardingConditions(appProfile, '2.6') && !shouldHide}
			handlerClose={() => {
				localStorage.setItem('2.6', 'true')
				setIsLocalHide(true)
			}}
			placement='top-start'
			tooltip={CONSTS.ON_BOARDING['2.6']}
		/>
	)
}

export const TableHint = memo(TableHint_)
